import { ClientMigration, HasMigrated, MigrationOptions } from 'client-migration/clientMigration.types';
import { Company } from 'companies/company.types';

export function shouldHide(migrationStatus: ClientMigration | null, hasMigrated: HasMigrated,
  hideCriteria: MigrationOptions, selectedCompany: Company | null)
: boolean {
  if (!!migrationStatus && (migrationStatus.cdh_wave_id || migrationStatus.cobra_wave_id)) {
    // company should not be null so assume client has been migrated
    if (!selectedCompany) {
      return true;
    }
    const hasCdh = !selectedCompany.isCobraOnly && !selectedCompany.isFmlaOnly;
    const hasCobra = selectedCompany.hasCobra || selectedCompany.hasRetiree;

    return shouldHideAfterMigration(hideCriteria, hasMigrated, hasCobra, hasCdh);
  }

  return false;
}

function shouldHideAfterMigration(hideCriteria: MigrationOptions, hasMigrated: HasMigrated,
  hasCobra: boolean, hasCdh: boolean): boolean {
  if (hideCriteria === MigrationOptions.both &&
        (!hasCdh ? true : hasMigrated.cdh) &&
        (!hasCobra ? true : hasMigrated.cobra)) {
    return true;
  }

  if (hideCriteria === MigrationOptions.cdhOnly &&
    (!hasCdh ? true : hasMigrated.cdh)) {
    return true;
  }

  if (hideCriteria === MigrationOptions.cobraOnly &&
    (!hasCobra ? true : hasMigrated.cobra)) {
    return true;
  }

  return false;
}

export function isPartiallyMigratedCobra(migrationStatus: ClientMigration | null, hasMigrated: HasMigrated,
  selectedCompany: Company | null): boolean {
  if (!hasBothPlanTypesScheduledForMigration(migrationStatus, selectedCompany)) {
    return false;
  }

  if (hasMigrated.cobra && !hasMigrated.cdh) {
    return true;
  }

  return false;
}

export function isPartiallyMigratedCdh(migrationStatus: ClientMigration | null, hasMigrated: HasMigrated,
  selectedCompany: Company | null): boolean {
  if (!hasBothPlanTypesScheduledForMigration(migrationStatus, selectedCompany)) {
    return false;
  }

  if (hasMigrated.cdh && !hasMigrated.cobra) {
    return true;
  }

  return false;
}

function hasBothPlanTypesScheduledForMigration(migrationStatus: ClientMigration | null,
  selectedCompany: Company | null): boolean {
  if (!selectedCompany || !migrationStatus) {
    return false;
  }

  if (!(selectedCompany.hasCobra || selectedCompany.hasRetiree)
    || !(!selectedCompany.isCobraOnly && !selectedCompany.isFmlaOnly)) {
    return false;
  }

  return true;
}
